import React from "react";
import { Modal, Button, Tag, Divider } from "antd";
import dayjs from "dayjs";
import { capitalizeAndRemoveUnderscores } from "../../utils/utils";
import { getBoxColor, getCircleColor, getStatusBadgeColor } from "../../utils/Constant";

const remarkColors = {
    send: "green",
    reject: "red",
    not_required: "orange",
    update: "blue",
    other: "purple",
};

const ApprovalDetailsModal = ({ visible, onClose, user }) => {
    if (!user) return null;
    const circleColor = getCircleColor(user.status.toLowerCase());
    const badgeClasses = getStatusBadgeColor(user.status.toLowerCase());

    return (
        <Modal
            title={null}
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="close" size="small" onClick={onClose}>
                    Close
                </Button>,
            ]}
            width={600}
            className="rounded-lg"
            style={{ backgroundColor: "transparent" }}
        >
            <div className={`p-2 ${getBoxColor(user.status.toLowerCase())} rounded-lg`}>
                <div className="flex items-center gap-3 mb-4">
                    <svg width="16" height="16" viewBox="0 0 10 10">
                        <circle
                            cx="5"
                            cy="5"
                            r="4"
                            stroke={circleColor.stroke}
                            fill={circleColor.fill}
                            strokeWidth="1"
                        />
                    </svg>
                    <h2 className="text-lg font-bold" style={{ color: circleColor.stroke }}>
                        {user.first_name} ({user.role})
                    </h2>
                    <Tag className={`ml-auto ${badgeClasses}`}>{user.status.toLowerCase()}</Tag>
                </div>

                {/* User Info */}
                <div className="space-y-2 text-sm">
                    <p>
                        <strong>Email:</strong> {user.email}
                    </p>
                    <p>
                        <strong>Scheduled Date:</strong>{" "}
                        {user.scheduled_date ? dayjs(user.scheduled_date).format("YYYY-MM-DD HH:mm") : "None"}
                    </p>
                    <p>
                        <strong>Agreement Status:</strong>{" "}
                        {capitalizeAndRemoveUnderscores(user.agreement_status) || "None"}
                    </p>
                </div>

                <Divider />
                <div>
                    <strong>Remarks:</strong>
                    <div className="mt-2 grid grid-cols-1 gap-2">
                        {["send", "reject", "not_required", "update", "other"].map((key) => {
                            const remarks = user.remarks_grouped?.[key]?.filter(r => r && r.trim());
                            if (!remarks || remarks.length === 0) return null;
                            let displayKey = key;
                            if (key === "reject") displayKey = "Rejected Remark";
                            if (key === "not_required") displayKey = "Cancelled Remark";
                            if (key === "send") displayKey = "Send Remark";

                            return (
                                <div key={key} className="flex items-center gap-2">
                                    <span className="font-semibold capitalize">{displayKey}:</span>
                                    <span>
                                        {remarks.map((r, i) => (
                                            <Tag color={remarkColors[key]} key={i}>
                                                {r}
                                            </Tag>
                                        ))}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <Divider />
                <div className="text-sm text-gray-700 dark:text-gray-300 flex justify-between mt-2">
                    <div>
                        <strong>Created At:</strong>{" "}
                        {user.created_at
                            ? dayjs(user.created_at).local().format("YYYY-MM-DD HH:mm")
                            : "N/A"}
                    </div>
                    <div>
                        <strong>Last Updated At:</strong>{" "}
                        {user.updated_at
                            ? dayjs(user.updated_at).local().format("YYYY-MM-DD HH:mm")
                            : "N/A"}
                    </div>
                </div>

            </div>
        </Modal>
    );
};

export default ApprovalDetailsModal;
